import React from 'react';

import Context     from '../../../../../../context';
import validations from '../../../../../../validations';

import { useFormik         } from 'formik';
import { useTranslation    } from 'react-i18next';
import { locationNamespace } from '../../../../../../types/location.namespace';

import {
  CustomIcon,
  CustomInput,
  CustomModal,
  CustomButton2,
  ResponsiveView, CustomLeaflet,
} from '../../../../../../components';

import './index.sass';
import CustomCheckbox from "../../../../../../components/CustomCheckbox";

const Create: React.FC = (): React.ReactElement => {

  // # =================================================================================================================
  // # --------------------------------------------- Start Validate Values ---------------------------------------------

  const [location, setLocation] = React.useState<Array<string>>([]);
  const { showModal, setShowModal, createFunction, isLoading } = React.useContext(Context.Location.Province);
  const { t } = useTranslation();

  // # ---------------------------------------------- End Validate Values ----------------------------------------------
  // # =================================================================================================================

  // * =================================================================================================================
  // * -------------------------------------------- Start Local Functions ----------------------------------------------

  const formik = useFormik<locationNamespace.province.create>({
    enableReinitialize: true,
    initialValues: {
      isCapital: false,

      key        : undefined,
      name       : '',
      prefix     : undefined,
      description: undefined,

      code      : undefined,
      population: undefined,

      location: {
        type: 'Point',
        coordinates: [NaN, NaN],
      },
    },
    validationSchema: validations.location.province.create,
    onSubmit: (values: locationNamespace.province.create, { setSubmitting }) => {
      const newValues: locationNamespace.province.create = {
        ...values,
        location: {
          type: 'Point',
          coordinates: [
            location[0] ? Number(location[0]) : NaN,
            location[1] ? Number(location[1]) : NaN,
          ]
        }
      }
      Promise.resolve(createFunction!(newValues)).catch((e) => setSubmitting(false));
    },
  });

  function submitHandler(): void {
    formik.submitForm();
  };

  function handleChangeLocation(lat: any, lng: any): void {
    setLocation([lat, lng]);
  }

  // * --------------------------------------------- End Local Functions -----------------------------------------------
  // * =================================================================================================================

  // ? =================================================================================================================
  // ? ----------------------------------------------- Start Return View -----------------------------------------------

  return (
    <section id="parent-create-modal-container">
      <CustomIcon
        icon="fa-sharp fa-solid fa-circle-plus"
        size="medium"
        hoverTitle={'ساخت استان'}
        onClick={() => {setShowModal!("CREATE")}}
      />
      <form onSubmit={submitHandler}>
        <CustomModal label='ساخت استان' open={showModal === "CREATE"} onClose={() => setShowModal!("NONE")}>
          <ResponsiveView.Container className="create-form-content">
            <br/>
            <hr/>
            <ResponsiveView.Row className="form-row">
              <ResponsiveView.Column medium={6}>
                <CustomInput
                  id="name"
                  name="name"
                  label={'نام استان'}
                  value={formik.values.name}
                  onValueChange={formik.handleChange}
                  formikProps={{onBlur: formik.handleBlur}}
                  error={formik.errors.name && formik.touched.name}
                  errorText={formik.errors.name}
                />
              </ResponsiveView.Column>
              <ResponsiveView.Column medium={6}>
                <CustomCheckbox label='پایتخت میباشد'/>
              </ResponsiveView.Column>
            </ResponsiveView.Row>
            <br/>
            <ResponsiveView.Row className='form-row'>
              <ResponsiveView.Column small={12}>
                <CustomLeaflet
                  onChangeLatAndLng={handleChangeLocation}
                  defaultLat={location[0]}
                  defaultLng={location[1]}
                />
              </ResponsiveView.Column>
            </ResponsiveView.Row>
            <br />
            <ResponsiveView.Row className="form-row">
              <ResponsiveView.Column medium={6}>
                <CustomInput
                  id="key"
                  key="key"
                  label={'شناسه استان'}
                  value={formik.values.key}
                  onValueChange={formik.handleChange}
                  formikProps={{onBlur: formik.handleBlur}}
                  error={formik.errors.key && formik.touched.key}
                  errorText={formik.errors.key}
                />
              </ResponsiveView.Column>
              <ResponsiveView.Column medium={6}>
                <CustomInput
                  id="prefix"
                  key="prefix"
                  label={'پیش شماره‌ی استان'}
                  value={formik.values.prefix}
                  onValueChange={formik.handleChange}
                  formikProps={{onBlur: formik.handleBlur}}
                  error={formik.errors.prefix && formik.touched.prefix}
                  errorText={formik.errors.prefix}
                />
              </ResponsiveView.Column>
            </ResponsiveView.Row>
            <hr/>
            <ResponsiveView.Row className="form-row">
              <ResponsiveView.Column large={6} medium={6} small={12}>
                <CustomButton2
                  isLoading={isLoading}
                  onClick={() => setShowModal!("NONE")}
                  title={t("cancel")}
                  type="danger"
                />
              </ResponsiveView.Column>
              <ResponsiveView.Column large={6} medium={6} small={12}>
                <CustomButton2 isLoading={isLoading} onClick={submitHandler} title={t("submit")}/>
              </ResponsiveView.Column>
            </ResponsiveView.Row>
          </ResponsiveView.Container>
        </CustomModal>
      </form>
    </section>
  );

  // ? ------------------------------------------------ End Return View ------------------------------------------------
  // ? =================================================================================================================

};

export default Create;
